var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"smarttable-footer-container"}},[_c('Section',{attrs:{"id":"smarttable-footer-left-wrapper"}}),_c('Section',{attrs:{"id":"smarttable-footer-right-wrapper"}},[(_vm.settings.pages.length > 1)?[_c('SmartTablePagination')]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }